<template>
    <div>
        <el-table
            v-if="isLoading === false"
            :data="tableData"
            style="width: 100%"
            class="fresh-seed-bag-table"
            size="mini"
            :header-cell-style="{ background: '#F5F7FA' }"
            border
        >
            <el-table-column
                type="index"
                width="30"
            />
            <el-table-column
                prop="transactionTime"
                label="Date"
                width="95"
                :formatter="transactionFormatter"
            />
            <el-table-column
                prop="discriminator"
                label="Transaction"
                min-width="100"
                :formatter="discriminatorFormatter"
            />
            <el-table-column
                prop="amount"
                label="Amount"
                width="70"
            />
        </el-table>
        <p v-else>Loading...</p>
    </div>
</template>

<script>
import { getAllFreshSeedTransaction } from "@/api/fresh_seed_transaction";

export default {
    props: {
        id: {
            type: String | Number
        }
    },
    data() {
        return {
            tableData: [],
            isLoading: false,
        };
    },
    watch: {
        id: {
            immediate: true,
            handler() {
                this.getAllTransaction();
            },
        },
        isLoading() {
            if (this.isLoading === true) {
                this.tableData = [];
            }
        }
    },
    methods: {
        async getAllTransaction () {
            this.isLoading = true;
            let res = await getAllFreshSeedTransaction({ "FreshSeedBagId": this.id, "DisablePaging": true });
            if (res) {
                this.tableData = res.items;
            }
            this.isLoading = false;
        },
        transactionFormatter(row, column, cell) {
            return this.$_getMyrDateFormat(cell);
        },
        discriminatorFormatter(row, column, cell) {
            switch (cell) {
            case "DistributeFreshSeed":
                return `Distribute to (${row.station?.name || "-"})`;

            case "DistributeFreshSeedToGermination":
                return "Send to germinate";

            case "DiscardFreshSeed":
                return `Discard due to ${row.discardReason}`;

            case "ReceiveFreshSeedProgeny":
                return `Receive from progeny (${row.progeny?.code || "-"})`;

            case "ReceiveFreshSeedGermplasm":
                return `Receive from germplasm (${row.germplasm?.progeny?.code || "-"})`;

            case "ReceiveFreshSeedStation":
                return `Receive from station (${row.station?.name || "-"})` ;

            default:
                break;
            }
        },
    },
};
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/FreshSeedTransaction/FreshSeedTransactionSimpleTable.vue